import type { FetchThemePageProps } from '~/types/themePage';

import { useQueryThemePagesV7 } from './useQueryThemePagesV7';
import { useQueryThemePagesV6 } from './useQueryThemePagesV6';
import { useThemePageStore } from '~/stores/themePage';
import { useMemo } from 'react';

export const useQueryThemePages = (props?: FetchThemePageProps) => {
  useQueryThemePagesV7(props);
  useQueryThemePagesV6(props);

  const dataThemePages = useThemePageStore((state) => state.themePages);
  const themePages = useMemo(() => dataThemePages, [dataThemePages]);
  // Memoized: an unstable array here propagates into callers' useCallback deps, re-running their
  // effects on every render.
  const defaultThemePages = useMemo(() => themePages?.filter((page) => page.default), [themePages]);

  return {
    themePages,
    defaultThemePages,
  };
};
export type IQueryThemePages = ReturnType<typeof useQueryThemePages>;
